import { render, staticRenderFns } from "./AddPracticalSurvey.vue?vue&type=template&id=55b04452&scoped=true&"
import script from "./AddPracticalSurvey.vue?vue&type=script&lang=js&"
export * from "./AddPracticalSurvey.vue?vue&type=script&lang=js&"
import style0 from "./AddPracticalSurvey.vue?vue&type=style&index=0&id=55b04452&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b04452",
  null
  
)

export default component.exports